import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Radio } from 'antd';
import styles from './styles';
import { textStyles } from '../../theme/fonts-ppv';
import './rbh-radio.css';

export const RBHRadio = (p: any) => {
  let style = p.style;
  if (p.disabled) {
    style = { ...p.style, ...styles.disabled };
  }
  return (
      <Radio
        className="rbh-radio"
        style={p.style ? p.style : style}
        value={p.value}
        disabled={p.disabled}
        id={p.id}
        data-testid={p['data-testid']}
      >
        {p.textOption ? <span style={textStyles.body2}><FormattedMessage id={p.textOption} /></span> : null}
        {p.children}
      </Radio>
  );
};

export default RBHRadio;
